import React, { type FC } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { Select } from 'mailup-web-components'

import { changeDatesTypeCallback } from 'Pages/RecipientsList/recoil/callbacks/filters'
import { criterionOptinDateState } from 'Pages/RecipientsList/recoil/state/filters'

interface InputDatesTypeProps {
  index: number
}

const InputDatesType: FC<InputDatesTypeProps> = ({ index }) => {
  const intl = useIntl()
  const { datesType } = useRecoilValue(criterionOptinDateState(index))

  const changeDatesType = useRecoilCallback(changeDatesTypeCallback, [])

  const options = [
    {
      value: 'beforeDate',
      label: intl.formatMessage({ id: 'Load.RecipientsList.DatesBeforeDate' }),
    },
    {
      value: 'afterDate',
      label: intl.formatMessage({ id: 'Load.RecipientsList.DatesAfterDate' }),
    },
    {
      value: 'interval',
      label: intl.formatMessage({ id: 'Load.RecipientsList.DatesInterval' }),
    },
  ]

  const handleChange = (v: 'beforeDate' | 'afterDate' | 'interval'): void => {
    //  void changeCriterion('datesType', v, index)
    void changeDatesType(v, index)
  }

  return (
    <Select
      value={datesType}
      onChange={handleChange}
      options={options}
      searchable={false}
      placeholder={intl.formatMessage({
        id: 'Load.RecipientsList.DatesTypePlaceholder',
      })}
      data-mu-test="select-dates-type"
    />
  )
}

export default InputDatesType
